import React from 'react';
import { string, node, bool, func } from 'prop-types';
import { noop } from 'lodash';
import cn from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';

import classes from './index.module.scss';

const DropdownFilterWrapper = ({
    className,
    children,
    title,
    applyButtonColor,
    canClear = false,
    onClear = noop,
    canApply = false,
    onApply = noop,
}) => (
    <div className={cn(classes.wrapper, className)}>
        <h6 className={cn(classes.title, 'text-display-7')}>{title}</h6>
        {children}
        <div className={classes.btnRow}>
            {canClear && (
                <Button
                    color={Button.COLORS.WHITE}
                    textColor={Button.TEXT_COLORS.DARK_GREY}
                    size={Button.SIZES.SMALL}
                    onClick={onClear}
                >
                    <I18n k="variations_display.general.clear_all" />
                </Button>
            )}
            <Button
                size={Button.SIZES.SMALL}
                color={applyButtonColor}
                disabled={!canApply}
                onClick={onApply}
            >
                <I18n k="variations_display.general.apply" />
            </Button>
        </div>
    </div>
);

DropdownFilterWrapper.propTypes = {
    className: string,
    children: node,
    title: node,
    applyButtonColor: string,
    canClear: bool,
    onClear: func,
    canApply: bool,
    onApply: func,
};

export default DropdownFilterWrapper;
